/**
 * Certifications Section for Assistant Profile
 * Allows selection of professional certifications
 */
import { Card } from "@/components/ui/card";
import { CERTIFICATIONS } from "@/lib/profileOptions";
import CheckBox from "./CheckBox";

export default function CertificationsSection({ certifications, setCertifications }) {
  const toggleCertification = (cert) => {
    if (certifications.includes(cert)) {
      setCertifications(certifications.filter(c => c !== cert));
    } else {
      setCertifications([...certifications, cert]);
    }
  };

  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">Certifications</h2>
      <div className="space-y-3">
        {CERTIFICATIONS.map((cert) => {
          const isSelected = certifications.includes(cert.value);
          return (
            <div 
              key={cert.value}
              className={`flex items-center gap-3 p-3 bg-white/[0.05] border rounded-sm cursor-pointer transition-all ${
                isSelected ? "border-white/40 bg-white/5" : "border-white/10"
              }`}
              onClick={() => toggleCertification(cert.value)}
              data-testid={`certification-${cert.value}`}
            >
              <CheckBox checked={isSelected} />
              <span>{cert.label}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
